var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import request from './request';
import { getCustomSettings, setCustomSettings } from '../utils/utils';
export var fetchPackDefinitions = function fetchPackDefinitions(resolvedAttributes) {
  var quantity = resolvedAttributes.find(function (each) {
    return each.attributeKey.toLowerCase() === 'shippable pack quantity';
  });
  var weight = resolvedAttributes.find(function (each) {
    return each.attributeKey.toLowerCase() === 'shippable pack weight';
  });

  if (quantity && weight) {
    return {
      quantity: quantity.attributeValue,
      weight: {
        value: weight.attributeValue,
        unit: weight.unitOfMeasure
      }
    };
  }

  return null;
};
export var fetchQuantityFromData = function fetchQuantityFromData(resolvedAttributes) {
  var quantity = resolvedAttributes.find(function (each) {
    return each.attributeKey.toLowerCase() === 'quantity' && each.class === 'order';
  });

  if (quantity) {
    return parseInt(quantity.attributeValue, 10);
  }

  return null;
};
export var getShippingConfiguration = function getShippingConfiguration() {
  return __awaiter(void 0, void 0, void 0, function () {
    var shipmentConfiguration;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4
          /*yield*/
          , getShippingConfigurationUser()];

        case 1:
          shipmentConfiguration = _a.sent();

          if (shipmentConfiguration) {
            return [2
            /*return*/
            , shipmentConfiguration];
          }

          return [2
          /*return*/
          , null];
      }
    });
  });
};
export var getProductionTimeForSku = function getProductionTimeForSku(mcpSku, resolvedAtrributes) {
  return __awaiter(void 0, void 0, void 0, function () {
    var skuProductionTime, response;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          skuProductionTime = {};
          if (!mcpSku) return [3
          /*break*/
          , 2];
          return [4
          /*yield*/
          , getProductionTime(mcpSku).catch(function () {})];

        case 1:
          response = _a.sent();

          if (response) {
            skuProductionTime[mcpSku] = {
              productionTime: response.Time,
              productionTimeUnits: response.Units
            };
            return [2
            /*return*/
            , skuProductionTime[mcpSku]];
          }

          return [2
          /*return*/
          , null];

        case 2:
          return [2
          /*return*/
          , null];
      }
    });
  });
};
export var getShippingConfigurationUser = function getShippingConfigurationUser() {
  return getCustomSettings('PRICEEXPLORER_SHIPPING_CONFIG').then(function (result) {
    return result && result.configuration;
  });
};
export var setShippingConfigurationUser = function setShippingConfigurationUser(configuration) {
  return setCustomSettings('PRICEEXPLORER_SHIPPING_CONFIG', {
    configuration: configuration
  });
};
export var getProductionTime = function getProductionTime(mcpSku) {
  return request("https://startingpriceapi.financialflows.cimpress.io/v1/productionTime/" + mcpSku);
};
export var calculateDays = function calculateDays(units, time) {
  switch (units) {
    case 'DD':
      return time;

    case 'HH':
      return Math.ceil(time / 24);

    default:
      return 0;
  }
};
export var createDeliveryRequest = function createDeliveryRequest(country, city, postalCode, isProduction, logger) {
  var deliveryRequestUrl = 'https://delivery.commerce.cimpress.io/v1/deliveryrequests';
  var nonPrdDeliveryRequestUrl = 'https://int-delivery.commerce.cimpress.io/v1/deliveryrequests';
  var baseURL = isProduction ? deliveryRequestUrl : nonPrdDeliveryRequestUrl;
  var data = {
    destinationAddress: {
      country: country,
      city: city,
      postalCode: postalCode
    }
  };

  try {
    return request(baseURL, 'POST', JSON.stringify(data)).then(function (result) {
      return result.deliveryRequestLink.href;
    }).catch(function (error) {
      logger.logError({
        message: 'Error in creating delivery request url',
        error: error
      }, 'Shipping');
    });
  } catch (error) {
    logger.logError({
      message: 'Error in creating delivery request url',
      error: error
    }, 'Shipping');
    return error;
  }
};
export var createProductConfiguration = function createProductConfiguration(mcpSku, attributeVariables, isProduction) {
  var configurationServiceUrl = 'https://configuration.products.cimpress.io/v1/configurations';
  var stgConfigurationServiceUrl = 'https://stg-configuration.products.cimpress.io/v1/configurations';
  var baseURL = isProduction ? configurationServiceUrl : stgConfigurationServiceUrl;
  var data = {
    mcpSku: mcpSku,
    variables: attributeVariables
  };
  return request(baseURL, 'POST', JSON.stringify(data));
};
export var getPromisedArrivalDate = function getPromisedArrivalDate(shippingTime) {
  var result = new Date();
  result.setDate(result.getDate() + shippingTime);
  return formatDate(result);
};

var formatDate = function formatDate(date) {
  var d = new Date(date);
  var month = "" + (d.getMonth() + 1);
  var day = "" + d.getDate();
  var year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  return [year, month, day].join('-');
};